@if (rendered()) {
  <div class="content" [class.web]="isWeb()">
    <div class="bg" [class.visible]="classesApplied()"></div>
    <div class="modal" [class.visible]="classesApplied()">
      <div class="header">
        <ion-icon (click)="close()" name="close"></ion-icon>
      </div>
      <div class="body">
        <div class="image">
          <img src="assets/scanning-escript.gif">
        </div>
        <h3>{{ title() }}</h3>
        <p>{{ description() }}</p>
      </div>
      <div class="controls">
        <app-button (click)="addScript()" label="Add eScript" />
        <!-- <app-button (click)="learnMore()" label="Learn more" bgColor="lighttint" /> -->
      </div>
    </div>
  </div>
}